import * as $ from "jquery";
import {DisabledHelper} from 'helpers/disabled-helper';

export class Helpers {
  static loadStyles(tag, src) {
    if (Array.isArray(src)) {
      $.each(src, function (k, s) {
        $(tag).append($('<link/>').attr('href', s).attr('rel', 'stylesheet').attr('type', 'text/css'));
      });
    } else {
      $(tag).append($('<link/>').attr('href', src).attr('rel', 'stylesheet').attr('type', 'text/css'));
    }
  }

  static unwrapTag(element) {
    $(element).removeAttr('appunwraptag').unwrap();
  }

  /**
   * Set title markup
   * @param title
   */
  static setTitle(title) {
    $('.m-subheader__title').text(title);
  }

  /**
   * Breadcrumbs markup
   * @param breadcrumbs
   */
  static setBreadcrumbs(breadcrumbs) {
    if (breadcrumbs) $('.m-subheader__title').addClass('m-subheader__title--separator');

    let ul = $('.m-subheader__breadcrumbs');

    if ($(ul).length === 0) {
      ul = $('<ul/>').addClass('m-subheader__breadcrumbs m-nav m-nav--inline')
        .append($('<li/>').addClass('m-nav__item')
          .append($('<a/>').addClass('m-nav__link m-nav__link--icon')
            .append($('<i/>').addClass('m-nav__link-icon la la-home'))));
    }

    $(ul).find('li:not(:first-child)').remove();
    $.each(breadcrumbs, function (k, v) {
      let li = $('<li/>').addClass('m-nav__item')
        .append($('<a/>').addClass('m-nav__link m-nav__link--icon').attr('routerLink', v.href).attr('title', v.title)
          .append($('<span/>').addClass('m-nav__link-text').text(v.text)));
      $(ul).append($('<li/>').addClass('m-nav__separator').text('-')).append(li);
    });
    $('.m-subheader .m-stack__item:first-child').append(ul);
  }

  static loadingCounter: number = 0;
  static countdownInterval: any = null;
  static isInterval: boolean = false;

  private static formatTime(seconds: number): string {
    let reservedTime = seconds +15
    let minutes = Math.floor(reservedTime / 60);
    reservedTime = reservedTime % 60;
    return `${minutes > 0 ? minutes + ' นาที ' : ''}${reservedTime} วินาที`;
  }

  static setLoading(enable: boolean, estimatedTime: number = null) {
    let body = $('body');

    if (enable) {
      this.loadingCounter++;

      $(body).find('.m-body input, .m-body textarea, .m-body button, .m-body label.btn, .m-body select').not('.m-bootstrap-select').each((index, element) => {
        DisabledHelper.disableInputElement(element, 'loading');
      });
      $(body).addClass('m-page--loading-non-block');

      if (estimatedTime !== null) {
        this.isInterval = true
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }
        this.countdownInterval = setInterval(() => {
          if (estimatedTime <= 0) {
            clearInterval(this.countdownInterval);
            this.isInterval = false
            return;
          }
          estimatedTime--;
          let displayTime = this.formatTime(estimatedTime);
          $('.m-blockui span').first().text(`กรุณารอสักครู่... โดยประมาณ ${displayTime}`);
        }, 1000);
      } else {
        $('.m-blockui span').first().text('กรุณารอสักครู่...');
      }
    } else {
      this.loadingCounter--;

      if (this.loadingCounter <= 0 || !this.isInterval) {
        this.loadingCounter = 0;  // Ensure the counter doesn't go negative

        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
        }

        $(body).find('.m-body input, .m-body textarea, .m-body button, .m-body label.btn, .m-body select').not('.m-bootstrap-select').each((index, element) => {
          DisabledHelper.enableInputElement(element, 'loading');
        });

        $(body).removeClass('m-page--loading-non-block');
      }
    }
  }



  static setPageInitialized(loaded) {
    let body = $('body');
    if (!loaded) {
      $(body).find('.m-body input, .m-body textarea, .m-body button, .m-body label.btn, .m-body select').not('.m-bootstrap-select').each((index, element) => {
        DisabledHelper.disableInputElement(element, 'initializing');
      });
    } else {
      $(body).find('.m-body input, .m-body textarea, .m-body button, .m-body label.btn, .m-body select').not('.m-bootstrap-select').each((index, element) => {
        DisabledHelper.enableInputElement(element, 'initializing');
      });
    }
  }

  static bodyClass(strClass) {
    $('body').attr('class', strClass);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers.ts